import { CompanyModule } from '../enums/companyModule.enum'

export enum ReleaseNoteType {
  // One big feature, hero visual
  SPOTLIGHT = 'spotlight',
  // "This month on SUMM": new / improved / fixed
  DIGEST = 'digest',
}

// Highest role of a member within a company; support accounts have none
export enum ReleaseNoteAudience {
  ADMIN = 'admin',
  LEAD = 'lead',
  EMPLOYEE = 'employee',
}

// Text fields may contain {{term:general.skills}} tokens (optionally |lower),
// resolved through t() so company terminology overrides apply
export interface IReleaseNoteItem {
  // Name from the SUMM icon set (src/components/icon/IconType.ts)
  icon?: string
  title: string
  // 2–4 sentences: what changed and the impact
  body: string
  // Optional specific features or wins, max 4
  points?: string[]
}

export interface IReleaseNoteContent {
  // Short one-line name for the list
  label: string
  title: string
  // One neutral sentence
  intro: string
  sections?: {
    new?: IReleaseNoteItem[]
    improved?: IReleaseNoteItem[]
    fixed?: IReleaseNoteItem[]
  }
}

export interface IReleaseNoteVariant {
  // Key of the schematic, brand-colored illustration for this audience
  // (src/components/releaseNotes/releaseNoteIllustrations.ts)
  illustration?: string
  nl: IReleaseNoteContent
  en: IReleaseNoteContent
}

export interface IReleaseNote {
  id: string
  type: ReleaseNoteType
  // ISO datetime; the go-live date of the release that ships the feature
  publishedAt: string
  // Being written: grows with every /ship, only support sees it (on every
  // environment alike), /release makes it final
  draft?: boolean
  requiredModule?: CompanyModule
  variants: Partial<Record<ReleaseNoteAudience, IReleaseNoteVariant>>
}

// A member's state: notes published before `since` never notify
export interface IMemberReleaseNotesState {
  audience: ReleaseNoteAudience
  since: Date
  openedIds: string[]
}

// Stored per company member in its own collection
export interface IReleaseNoteStatePure extends IMemberReleaseNotesState {
  _id: string
  companyId: string
  memberId: string
}
